import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';

import { useProvider, Toast } from '../../context/MenuProvider';
import { Link, useParams, useNavigate} from 'react-router-dom';


const PagamentoContent = ({ venda, setVenda}) => {
  const {
    crud,
    auth,
  } =useProvider();
  const navigate = useNavigate();
  const { loading } = crud || {};
  const [naUltima, setNaUltima] = useState(true);
  const [empresa, setEmpresa] = useState(auth);
  
  const gerarLinha = () => {
    if (venda?.itens?.length > 0 && venda?.pagamentos?.length <= 0) {
        return adicionarLinha();
    }

    const totalPago = venda?.pagamentos
        ?.filter(x => x.pago)
        .reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0) || 0;

    const total = parseFloat(venda?.total || 0);
    const desconto = parseFloat(venda?.desconto || 0);
    const totalAberto = total - totalPago - desconto;

    const temLinhaAberto = venda?.pagamentos?.some(x => !x.pago);
    
    if (totalAberto > 0 && !temLinhaAberto) {
        adicionarLinha();
    }
  };

  const setDesconto = (value) => {
    // Converte o valor para número ou define como 0 se inválido
    let valor = parseFloat(value || 0);
  
    // Garante que o desconto não seja negativo
    if (valor < 0) {
      valor = 0;
    } else {
      // Obtém o total da venda
      const total = parseFloat(venda?.total || 0);
  
      // Verifica se há pagamentos marcados como "pago"
      const pagamentos = venda?.pagamentos || [];
      const pagamentosPagos = pagamentos.filter((x) => x.pago);
      const temLinhaPago = pagamentosPagos.length > 0;
  
      // Calcula o total pago
      const totalPago = pagamentosPagos.reduce(
        (acc, linha) => acc + parseFloat(linha.valor || 0),
        0
      );
  
      // Calcula o total em aberto
      let totalAberto = total - totalPago;
      //se o total do desconto é o mesmo de valor em aberto e nao tem nenhum pago
      if (!temLinhaPago) {
        totalAberto -= 0.01; // Ajuste conforme a lógica específica
      }
  
      // Garante que o valor do desconto não exceda o total aberto
      if (valor > totalAberto) {
        valor = parseFloat(totalAberto.toFixed(2));
      }
    }
  
    // Atualiza o estado da venda com o novo desconto
    setVenda((prevVenda) => ({
      ...prevVenda,
      desconto: value?valor:value,
    }));
  };
  

  // Função para dividir o total da sacola pelas linhas não paga
  const dividirTotal = () => {
    const linhasNaoPagas = venda.pagamentos?.filter((linha) => !linha.pago) || [];
    const totalGeral = parseFloat(venda.total || 0) - parseFloat(venda.desconto||0);
  
    // Subtrai o valor das linhas pagas do total restante
    const valorCongelado = venda.pagamentos?.filter((linha) => linha.pago)
      .reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0) || 0;
  
    const totalRestante = totalGeral - valorCongelado;
    
    let novaTabela = [];
    //Ajustar para ultima linha se tiver valor nao pago
    if (naUltima && linhasNaoPagas.length > 0) {
      const valorTotal = venda.pagamentos?.filter((linha) => !linha.pago)
        .reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0) || 0;
  
      // Se naUltima for true, apenas altera a última linha não paga
      const ultimaLinhaNaoPaga = linhasNaoPagas[linhasNaoPagas.length - 1];
  
      // Atualiza o valor da última linha não paga com o valor total restante
      ultimaLinhaNaoPaga.valor = (totalRestante - valorTotal + parseFloat(ultimaLinhaNaoPaga.valor||0)).toFixed(2) //(totalGeral - valorTotal).toFixed(2);
      //alert(`Valor Total: ${valorTotal} Valor Geral: ${totalGeral} Diferença: ${ultimaLinhaNaoPaga.valor}`);
  
      // Atualiza a tabela com o novo valor da última linha
      novaTabela = venda.pagamentos?.map((linha) =>
        linha === ultimaLinhaNaoPaga ? ultimaLinhaNaoPaga : linha
      )||[];
  
      // Exclui as linhas com valor <= 0
      novaTabela = novaTabela.filter((linha) => parseFloat(linha.valor||0) > 0 || linha.valor==="");
      if (JSON.stringify(venda.pagamentos) !== JSON.stringify(novaTabela)) {
        setVenda((prevVenda) => ({
          ...prevVenda,
          pagamentos: novaTabela,
        }));
      }
      
    } else if (linhasNaoPagas.length > 0) {
      // Caso contrário, divide o valor entre todas as linhas não pagas
      let valorPorLinha =
        linhasNaoPagas.length > 0 ? totalRestante / linhasNaoPagas.length : 0;
  
      // Arredonda o valor por linha para 2 casas decimais
      valorPorLinha = Math.round(valorPorLinha * 100) / 100;
  
      // Calcula a diferença do total geral, considerando o arredondamento
      const somaValorPorLinha = valorPorLinha * linhasNaoPagas.length;
      const ajuste = totalRestante - somaValorPorLinha;
  
      // Atualiza a última linha para corrigir a diferença
      novaTabela = venda.pagamentos?.map((linha, index) => {
        if (!linha.pago) {
          const valorAtualizado =
            index === linhasNaoPagas.length - 1
              ? (valorPorLinha + ajuste).toFixed(2)
              : valorPorLinha.toFixed(2);
          return { ...linha, valor: valorAtualizado };
        }
        return linha;
      })||[];
  
      // Exclui as linhas com valor <= 0
      novaTabela = novaTabela.filter((linha) => parseFloat(linha.valor) > 0 || linha.valor==="");
      if (JSON.stringify(venda.pagamentos) !== JSON.stringify(novaTabela)) {
        setVenda((prevVenda) => ({
          ...prevVenda,
          pagamentos: novaTabela,
        }));
      }
    }
    
    
  };
  
  // Função para ajustar a última linha não paga
  const ajustarUltimaLinhaNaoPaga = () => {
    const linhasNaoPagas = venda.pagamentos?.filter((linha) => !linha.pago)||[];
    const totalNaoPagos = parseFloat(venda.total || 0) - parseFloat(venda.desconto||0);

    const valorCongelado = venda.pagamentos?.filter((linha) => linha.pago)
      .reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0)||0;

    const totalRestante = totalNaoPagos - valorCongelado;

    const valorPorLinha = totalRestante / linhasNaoPagas.length;

    const novaTabela = venda.pagamentos?.map((linha, index) => {
      if (!linha.pago && index === venda.pagamentos?.length - 1) {
        return { ...linha, valor: valorPorLinha.toFixed(2) };
      }
      return linha;
    })||[];

    setVenda((prevVenda) => ({
      ...prevVenda,
      pagamentos: novaTabela,
    }))
  };

  // Função para adicionar uma nova linha com a data ajustada
  const adicionarLinha = () => {
    try {
      setNaUltima(false);
      let novaData;
      if (venda?.pagamentos?.length > 0) {
        // Se houver pelo menos uma linha, adiciona 7 dias à última data
        const ultimaLinha = venda.pagamentos[venda.pagamentos.length - 1];
        novaData = new Date(ultimaLinha.data);
  
        if (isNaN(novaData)) throw new Error("Data inválida na última linha.");
        const dias_parcelamento = empresa?.configuracoes?.dias_parcelamento || 7;
        novaData.setDate(novaData.getDate() + dias_parcelamento); // Adiciona 7 dias à última data
      } else {
        // Se não houver nenhuma linha, usa a data inicial
        novaData = new Date(venda?.data || Date.now());
  
        if (isNaN(novaData)) throw new Error("Data inicial inválida.");
      }
  
      const novaLinha = {
        valor: 0,
        pago: false,
        data: novaData.toISOString().split('T')[0], // Formata para 'YYYY-MM-DD'
        pagamento: 'pix',
      };
  
      const novaTabela = [...(venda?.pagamentos || []), novaLinha];
  
      novaTabela.sort((a, b) => new Date(a.data) - new Date(b.data)); // Ordena as linhas pela data
  
      setVenda((prevVenda) => ({
        ...prevVenda,
        pagamentos: novaTabela,
      }));
    } catch (error) {
      console.error("Erro ao adicionar linha:", error.message);
    }
  };

  // Função para remover uma linha da tabela
  const removerLinha = (index) => {
    const novaTabela = venda.pagamentos?.filter((linha, i) => i !== index || linha.pago)||[];
    setVenda((prevVenda) => ({
      ...prevVenda,
      pagamentos: novaTabela,
      
    }))
  };

  // Função para lidar com alterações nos inputs
  const handleInputChange = (index, field, value) => {
    const novaTabela = [...venda.pagamentos||[]];

    // Se o campo for "valor" e a linha não está paga
    if (field === "valor" && !novaTabela[index].pago) {
      novaTabela[index][field] = value.value;

      // Ajusta a última linha não paga quando o valor for alterado
      //ajustarUltimaLinhaNaoPaga();
    }
    
    if (field === "data" && !novaTabela[index].pago) {
      novaTabela[index][field] = value.value;

      // Ajusta a última linha não paga quando o valor for alterado
      ajustarUltimaLinhaNaoPaga();
    }
    
    if (field === "pagamento" && !novaTabela[index].pago) {
      novaTabela[index][field] = value.value;

      // Ajusta a última linha não paga quando o valor for alterado
      ajustarUltimaLinhaNaoPaga();
    }

    // Se o campo for "pago", congela o valor quando pago
    if (field === "pago") {
      novaTabela[index][field] = value.checked;

      // Congela o valor da linha quando marcada como paga
      if (value.checked) {
        //novaTabela[index].valor = novaTabela[index].valor; // Congela o valor
      }
    }

    // Verifica se a última linha tem valor <= 0 e não está paga
    if (novaTabela[novaTabela.length - 1].valor <= 0 && !novaTabela[novaTabela.length - 1].pago && value) {
      novaTabela.pop(); // Remove a última linha se o valor for <= 0
    }

    // Reordena a tabela pela data, mesmo que a linha tenha sido paga
    novaTabela.sort((a, b) => new Date(a.data) - new Date(b.data));

    // Atualiza a tabela
    setVenda((prevVenda) => ({
      ...prevVenda,
      pagamentos: novaTabela,
      
    }))
  };
  const handleInputChangeFixed = (index, field, value) => {
    const novaTabela = [...venda.pagamentos||[]];

    // Se o campo for "valor" e a linha não está paga
    if (field === "valor" && !novaTabela[index].pago) {
      novaTabela[index][field] = parseFloat(value.value||0).toFixed(2);
    }
    
    // Reordena a tabela pela data, mesmo que a linha tenha sido paga
    //novaTabela.sort((a, b) => new Date(a.data) - new Date(b.data));

    // Atualiza a tabela
    setVenda((prevVenda) => ({
      ...prevVenda,
      pagamentos: novaTabela,
      
    }))
  };


  useEffect(() => {
    gerarLinha();
    dividirTotal();
  }, [venda?.itens, venda?.pagamentos, venda?.total, venda?.desconto]);
  

  return (
    <div className="pb-5">
      <div className="row">
        <div className="col-auto">
          <div className="text-muted small">Produtos</div>
            <Button id="btnCkAddMaisProdutos" variant="secondary" onClick={() => navigate(`/checkout/adicionar-produtos`, {replace:true})} disabled={loading} className="mt-2 mb-5 text-center">
                <i className="bi bi-plus"></i> Adicionar produtos
            </Button>
        </div>
        <div className="col">
          <small className="text-muted">Desconto</small>
          <div id="btnCkAddDesconto" className="input-group">
            <span className="input-group-text">R$</span>
            <input
              type="number"
              className="form-control"
              value={venda?.desconto}
              onChange={(e) => setDesconto(e.target.value)}
              onBlur={(e) => setVenda((prevVenda) => ({
                ...prevVenda,
                desconto: parseFloat(venda.desconto||0).toFixed(2),
              }))}
            />
          </div>
        </div>
      </div>
      <h6 className="border-dashed-bottom">Forma de pagamento</h6>
      <div id="listaCkPagamentos" className="table-responsive">
        <table className="table w-100">
          <thead>
            <tr>
              <th>Valor</th>
              <th>Pago</th>
              <th>Data</th>
              <th>Pagamento</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {venda.pagamentos?.map((linha, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    value={linha.valor}
                    readOnly={linha.pago} // Congela o valor quando pago
                    onChange={(e) => handleInputChange(index, "valor", e.target)}
                    onBlur={(e) => { handleInputChangeFixed(index, "valor", e.target);}}
                    onFocus={(e) => { setNaUltima(true); }} // Função ao focar
                  />
                </td>
                <td className="text-center align-middle">
                  <Form.Check
                    type="switch"
                    id={`custom-switch-${index}`}
                    
                    checked={linha.pago}
                    onChange={(e) => handleInputChange(index, "pago", e.target)}
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={linha.data}
                    onChange={(e) =>
                      handleInputChange(index, "data", e.target)
                    }
                  />
                </td>
                <td>
                  <select
                    className="form-select form-select-sm"
                    value={linha.pagamento}
                    onChange={(e) => handleInputChange(index, "pagamento", e.target)}
                  >
                    <option value="pix">Pix</option>
                    <option value="dinheiro">Dinheiro</option>
                    <option value="cartao">Cartão</option>
                    <option value="online">Link</option>
                  </select>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => removerLinha(index)}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-center">
          <button
            id="btnAddCkPagamentos"
            className="btn btn-dark mb-5 mt-3 btn-sm w-100"
            onClick={adicionarLinha}
          >
            Criar nova parcela
          </button>
      </div>
    </div>
  );
};


export default PagamentoContent